"use client"

import { useLocation } from "react-router-dom"

function normalizePathname(pathname: string): string {
  if (!pathname) return "/"
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1)
  }
  return pathname
}

/** Normalized path (no trailing slash except root) for nav highlighting and guards. */
export function usePathnameSafe(): string {
  const { pathname } = useLocation()
  return normalizePathname(pathname)
}
